import { NAME as PARENT_NAME, ROUTES as PARENT_ROUTES } from '../constants';

export const NAME = `${PARENT_NAME}/START_MANIFEST`;
export const REDUCER_NAME = 'startManifest';

export const FORM_NAME = NAME;

export const ROUTES = {
  ROOT: `${PARENT_ROUTES.ROOT}/start`,
};
